import React from 'react'
import { Dimensions, Platform, StyleSheet, Text, View } from 'react-native'
import { TemplatePage } from '../../components/TemplatePage'
import { corporateColor, toqueColor, white, whiteBackgroundColor } from '../../theme/colors'
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { TouchableOpacity } from 'react-native'
import { StackNavigationProp } from '@react-navigation/stack'
import { CommonActions, RouteProp, useNavigation, useRoute } from '@react-navigation/native'
import { RootParams } from '../../navigator/types'
const WIDTH_WINDOW = Dimensions.get('window').width

interface NavigationParams extends StackNavigationProp<RootParams, 'SuccessScreen'> {}
export const SuccessScreen = () => {
  const navigation = useNavigation<NavigationParams>()
  const route = useRoute<RouteProp<RootParams, 'SuccessScreen'>>()

  return (
    <TemplatePage styleContent={{ padding: 0 }}>
      <View style={styles.container}>
        <View style={styles.iconContainer}>
          <FontAwesomeIcon icon={faCheck} size={60} color={white} />
        </View>
        <View>
          <Text style={styles.text}>Formulario enviado correctamente</Text>
        </View>

        <TouchableOpacity
          style={styles.backButton}
          activeOpacity={0.8}
          onPress={() => {
            if (route.params?.goNewForm) {
              navigation.dispatch(
                CommonActions.reset({
                  index: 1,
                  routes: [{ name: 'HomeScreen' }, { name: 'ControlServicesStack' }],
                }),
              )

              return
            }

            navigation.replace('HomeScreen')
          }}
        >
          <Text style={styles.textButton}>VOLVER AL INICIO</Text>
        </TouchableOpacity>
      </View>
    </TemplatePage>
  )
}
const styles = StyleSheet.create({
  container: {
    backgroundColor: whiteBackgroundColor,
    height: 350,
    borderRadius: 30,
    ...(Platform.OS === 'web' ? {minWidth: 300, maxWidth: 600, width: '100%'} : {width: WIDTH_WINDOW}),
    bottom: 0,
    position: 'absolute',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  iconContainer: {
    backgroundColor: corporateColor,
    borderRadius: 50,
    width: 100,
    height: 100,
    padding: 20,
  },

  text: {
    color: corporateColor,
    fontWeight: 'bold',
    fontSize: 19,
  },

  backButton: {
    backgroundColor: toqueColor,
    ...(Platform.OS === 'web' ? {minWidth: 300, maxWidth: 600, width: '80%'} : {width: WIDTH_WINDOW*0.8}),
    borderRadius: 15,
    height: 53,
    justifyContent: 'center',
    alignItems: 'center',
  },

  textButton: {
    color: white,
    fontWeight: 'bold',
    fontSize: 17,
  },
})
